import defaults from "../../i18n/authForm.js";
import { getBrowserLanguage } from "../../i18n/language.js";

const hasText = (value) => typeof value === "string" && value.trim().length > 0;
const suppliedTexts = (values) => Object.fromEntries(
    Object.entries(values ?? {}).filter(([, value]) => hasText(value))
);

export function resolveAuthI18n(translations = {}, locale) {
    const fallback = defaults[getBrowserLanguage(locale)] ?? defaults.en;
    const errors = translations?.errorMessages ?? {};
    return { ...fallback, ...suppliedTexts(translations), errorMessages: {
        ...fallback.errorMessages, ...suppliedTexts(errors),
        customerNumber: [errors.customerNumber, errors.customerId].find(hasText) ?? fallback.errorMessages.customerNumber,
        user: [errors.user, errors.username].find(hasText) ?? fallback.errorMessages.user
    } };
}
